import { transformDateValue } from 'core/js/FormUtils';
export const getMfproductView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mfproductList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"Title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
                            {"fieldLabel":"Description","fieldValue":transformDataValue(data.description,"string"), "fieldType":"string"},
                            {"fieldLabel":"Stock Count","fieldValue":transformDataValue(data.stockcount,"number"), "fieldType":"number"},
                            {"fieldLabel":"Category Id","fieldValue":transformDataValue(data.categoryid,"bodynamiclist"), "fieldType":"bodynamiclist"},
                            {"fieldLabel":"Category Name","fieldValue":transformDataValue(data.categoryname,"string"), "fieldType":"string"},
                            {"fieldLabel":"Stock Incoming","fieldValue":transformDataValue(data.stockincoming,"number"), "fieldType":"number"},
                            {"fieldLabel":"Price","fieldValue":transformDataValue(data.price,"double"), "fieldType":"double"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mfproductList.push(card);
  })
  return mfproductList;
}